export default __webpack_public_path__ + "static/media/svg-1.938c56a2.svg";